import { render, staticRenderFns } from "./purchasesReturns.vue?vue&type=template&id=4006ec2e&scoped=true&"
import script from "./purchasesReturns.vue?vue&type=script&lang=js&"
export * from "./purchasesReturns.vue?vue&type=script&lang=js&"
import style0 from "./purchasesReturns.vue?vue&type=style&index=0&id=4006ec2e&lang=less&scoped=true&"
import style1 from "./purchasesReturns.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4006ec2e",
  null
  
)

component.options.__file = "purchasesReturns.vue"
export default component.exports